
/**
 * Imports.
 */

import Highlight from 'syntax-highlighter'

/**
 * Languages.
 */

import bash from 'highlight-bash'
import csharp from 'highlight-csharp'
import go from 'highlight-go'
import java from 'highlight-java'
import js from 'highlight-javascript'
import objc from 'highlight-objective-c'
import php from 'highlight-php'
import python from 'highlight-python'
import ruby from 'highlight-ruby'
import sql from 'highlight-sql'
import xml from 'highlight-xml'
import yaml from 'highlight-yaml'
import css from 'highlight-css'
import './highlight.css'

/**
 * Highlight.
 */

let highlight = new Highlight()
  .use(js)
  .use(bash)
  .use(objc)
  .use(csharp)
  .use(python)
  .use(java)
  .use(ruby)
  .use(sql)
  .use(xml)
  .use(css)
  .use(php)
  .use(go)
  .use(yaml)

/**
 * Exports.
 */

export default highlight



// WEBPACK FOOTER //
// ./ui/highlight.js